<template>
    <div>
      <navgate ></navgate>
      <main ref="containerDiv" class="index_main_content">
        <!--首页视频-->
        <section class="index_video_section" data-wg="" style="background-color:#000000" data-mb-image="">
          <video loop muted autoplay="autoplay" poster="../../assets/video/video-1.png" class="index_video" ref="videoRef" id="videoRef" playsinline x5-video-player-type="h5">
              <source src="../../assets/video/movie-10.mp4" type="video/mp4">
          </video>
          
          <div class="index_video_text" @click="gotoBody">
            <div class="video_title">梦想金山</div>
            <i class="iconfont icon-website-xiangxia hvr-hang"></i>
          </div>
        </section>
        <!--首页内容-->
        <div class="index_main_body" ref="centerbody">
            <div  class="zcgy_img"><img src="../../assets/img/index/zcgy-banner.jpg"><div class="mask_bg"></div></div>
          <!-- <div  class="zcgy_img"><img ref="testAna" :class="Animate1 ? 'myanimation' : ''" src="../../assets/img/zcgy_nav.png"></div> -->
          <div class="zcgy_word">
            <div class="zcgy_ch">志存高远 脚踏实地</div>
            <div class="zcgy_en">Keep high aspirations with feet on the ground</div>
          </div>
        </div>
        <div class="index_flex_layout">
          <div class="index_three_width">
          <div class="index_text_layout">
            <div class="text_title">技术立业</div>
            <div class="text_word">以技术创新为先导，以技术进步为根本驱动，以技术支撑产品和交付以赢得用户</div>
            <div class="index_se_hover_box">
              <img src="../../assets/img/index/three-1.jpg">
              <div class="index_se_title">技术立业</div>
            </div>
          </div>
          <div class="index_text_layout">
            <div class="text_title">梦想</div>
            <div class="text_word">人因梦想而伟大</div>
            <div class="index_se_hover_box">
              <img src="../../assets/img/index/three-2.jpg">
              <div class="index_se_title">梦想</div>
            </div>
          </div>
          <div class="index_text_layout">
            <div class="text_title">兄弟抱团打天下</div>
            <div class="text_word">创业路上，一个人可以走的更快<br>但是一群人可以走的更远</div>
            <div class="index_se_hover_box">
              <img src="../../assets/img/index/three-3.jpg">
              <div class="index_se_title">兄弟抱团打天下</div>
            </div>
          </div>
        </div>
          <div v-if="mainData && mainData.introduce && mainData.introduce.messageNews" class="index_news_layout">
            <div class="in_news_top" @click="toDetailPage(mainData.introduce.messageNews[0]['messageId'])">
              <img :src="mainData.introduce.messageNews[0]['msgUrl']">
              <div class="in_news_hover_bg news_index_p">
                <div class="news_hover_title large">{{mainData.introduce.messageNews[0]['title']}}</div>
                <div class="news_hover_word">{{mainData.introduce.messageNews[0]['secondTitle']}}</div>
                <i class="iconfont icon-website-xiangyou"></i>
              </div>
            </div>
            <div class="in_news_bottom">
              <div class="in_news_list" @click="toDetailPage(mainData.introduce.messageNews[1]['messageId'])">
                <img :src="mainData.introduce.messageNews[1]['msgUrl']">
                <div class="in_news_hover_bg">
                  <div class="news_hover_title">{{mainData.introduce.messageNews[1]['title']}}</div>
                  <div class="news_hover_word">{{mainData.introduce.messageNews[1]['secondTitle']}}</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
              </div>
              <div class="in_news_list" @click="toDetailPage(mainData.introduce.messageNews[2]['messageId'])">
                <img :src="mainData.introduce.messageNews[2]['msgUrl']">
                <div class="in_news_hover_bg">
                  <div class="news_hover_title">{{mainData.introduce.messageNews[2]['title']}}</div>
                  <div class="news_hover_word">{{mainData.introduce.messageNews[2]['secondTitle']}}</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="index_main_body2">
          <div class="zcgy_img"><img src="../../assets/img/index/mxjs.jpg"><div class="mask_bg"></div></div>
          <div class="zcgy_word">
            <div class="zcgy_ch">梦想金山</div>
            <div class="zcgy_en">Dreams Never Lost at Kingsoft</div>
          </div>
        </div>
      </main>
      <footerBuild @gotoBody="gotoBody"></footerBuild>
      
      
    </div>
  </template>
  <script>

  import UtilEvent from './utils/UtilEvent.js'
  export default {
    name: 'homePage',
    components:{UtilEvent},
    props: {
      
    },
    created(){
        new UtilEvent().getMainData(this);
    },
    data () {
      return {
        Animate1:false,
        lockTop:false,
        mainData:null,
        oldScrollTop:0,
        
      }
    },
    computed:{
      
    },
    methods:{
      
        toDetailPage(messageId){
      
          let url = this.$router.resolve({
            name: 'newsDetail',
            query: {detailId:messageId}
          });
          this.$PageUtil.openNewPage(this,url.href)
          
        },
        gotoBody(){
            this.$refs.centerbody.scrollIntoView({
                behavior: "smooth",  // 平滑过渡
            });
        }
    },
    watch:{
      
    },
    mounted(){
     
      var audio = document.getElementById("videoRef");
        audio.play();
        // audio.pause();
        var myPlay = function() {
          document.removeEventListener("WeixinJSBridgeReady", myPlay);
          document.removeEventListener("YixinJSBridgeReady", myPlay);
          audio.play();
          // audio.pause();
        };
        //weixin 监听到，执行play
        document.addEventListener("WeixinJSBridgeReady", myPlay, false);

        //刚加载页面后会有偏移量，便宜后再去监听
        
        new UtilEvent().initSystemModel();
        
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="less"> 
    
  </style>
  